import { createDialog, clearDialog } from '@edge/spark/feature-dialog'
import { Organization } from '../generated/graphql'
import { getActiveAuctionId, setActiveAuctionId } from '../activeAuctionIdStore'

const errorId = 'validateAuthorizedAuctions'

type ValidateAuthorizedAuctionsOptions = {
    /** Show dialog with errors */
    errorDialog?: boolean
}

/** Intended to be used during any `useAllOrganizations`/`getAllOrganizations` query which will set the first auction if none exists,
 *  or reset to the first auction if the active auction is no longer authorized.
 *
 * TODO: Separate validation logic from sync logic */
export const validateAuthorizedAuctions = (organizations: Organization[], opts?: ValidateAuthorizedAuctionsOptions) => {
    const { errorDialog = true } = opts || {}

    if (!organizations) {
        if (errorDialog) {
            const message = 'SPARK User organizations not found'
            createDialog({ message, id: errorId, timeout: 5000 })
        }
        return false
    }

    if (organizations.length === 0) {
        if (errorDialog) {
            const message =
                'Your Spark login is not associated with your auction. Please contact Auction Edge Customer Support at 800-522-8404 to get this issue resolved.'
            createDialog({ message, id: errorId, timeout: 5000 })
        }
        return false
    }

    const savedAuctionId = getActiveAuctionId()
    const maybeActiveOrganization = organizations?.find((org) => org?.orgId === savedAuctionId)

    if (maybeActiveOrganization) {
        clearDialog(errorId)
        return true
    }

    const firstOrganizationId = organizations[0].orgId

    if (firstOrganizationId) {
        setActiveAuctionId(firstOrganizationId)
        clearDialog(errorId)
        return false
    }

    if (errorDialog) {
        const message = 'SPARK organizations may be corrupted. Please logout and try again.'
        createDialog({ message, id: errorId, timeout: 5000, action: 'LOGOUT' })
    }

    return false
}
